/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venueflyerwhen2Inputs */

const en_venueflyerwhen2 = /** @type {(inputs: Venueflyerwhen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whenever something's on here`)
};

const de_venueflyerwhen2 = /** @type {(inputs: Venueflyerwhen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann immer hier was los ist`)
};

/**
* | output |
* | --- |
* | "Whenever something's on here" |
*
* @param {Venueflyerwhen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueflyerwhen2 = /** @type {((inputs?: Venueflyerwhen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueflyerwhen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueflyerwhen2(inputs)
	return de_venueflyerwhen2(inputs)
});
export { venueflyerwhen2 as "venueFlyerWhen" }